import { render } from "./SignInOauth.vue?vue&type=template&id=0d4796bb&ts=true&lang=pug"
import script from "./SignInOauth.vue?vue&type=script&lang=ts"
export * from "./SignInOauth.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__